// extracted by mini-css-extract-plugin
export default {"container":"CreatePurchase_container__nvCUn"};